import { Web3ReactProvider } from "@web3-react/core";
import { FC, ReactNode, useMemo } from "react";
import { useWeb3Connectors } from "./Web3ConnectorsProvider";

export const Web3ReactProviderSupplier: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { connectors } = useWeb3Connectors();

  const web3ConnectorsKey = useMemo(
    () => connectors.reduce((acc, _, index) => acc + index, ""),
    [connectors],
  );

  return (
    <Web3ReactProvider key={web3ConnectorsKey} connectors={connectors}>
      {children}
    </Web3ReactProvider>
  );
};
